import { createContext } from 'react';

type SaveHandler = () => void | Promise<void>;

export interface AdminSaveRegistration {
    hasChanges: boolean;
    isSaving?: boolean;
    onSave: SaveHandler;
    onDiscard: SaveHandler;
    saveLabel?: string;
    discardLabel?: string;
}

export interface RegisteredSaveHandler extends AdminSaveRegistration {
    routeId: string;
}

export interface AdminSaveContextValue {
    activeHandler: RegisteredSaveHandler | null;
    registerSaveHandler: (routeId: string, registration: AdminSaveRegistration) => void;
    unregisterSaveHandler: (routeId: string) => void;
}

export const AdminSaveContext = createContext<AdminSaveContextValue | null>(null);
